import React from 'react';
import { IconCircleButton } from './IconCircleButton';
import { AnimatedTitle } from './AnimatedTitle';
import { Reveal } from './Reveal';
import { imagenes } from '../data/site';
export function Hero() {
  return <section id="hero" className="relative isolate flex min-h-[100svh] w-full items-center overflow-hidden bg-[#0D0D0D]" data-id="element-59" data-mp="9lv16qmocfvu">
      <img src={imagenes.hero} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover" data-id="element-60" data-mp="4jm5vnmbx1qk" />
      <div className="absolute inset-0 bg-[#0D0D0D]/60" aria-hidden="true" data-id="element-61" data-mp="xa4ef45tnvbd" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0D0D0D] via-[#0D0D0D]/20 to-[#0D0D0D]/75" aria-hidden="true" data-id="element-62" data-mp="sb1bpqdbe16k" />

      <div className="relative mx-auto w-full max-w-7xl px-6 pb-28 pt-40 lg:px-12 lg:pb-36 lg:pt-48" data-id="element-63" data-mp="nbomx02vuk1c">
        <div className="max-w-3xl text-center sm:text-left" data-id="element-64" data-mp="3d2torapbqmf2">
          <Reveal data-id="element-65" data-mp="3825yir8x69lw">
            <h1 className="font-serif text-[2.6rem] leading-[1.05] text-white sm:text-6xl lg:text-7xl" data-id="element-66" data-mp="381nw1cvnyz5j">
              DESCUBRE EL PODER DE
            </h1>
          </Reveal>
          <Reveal delay={0.08} data-id="element-67" data-mp="3o858328mtl0c">
            <AnimatedTitle as="h2" text="LA MAGIA ANCESTRAL" className="candle-glow mt-1 font-serif text-[2.6rem] leading-[1.05] text-[#E0A526] sm:text-6xl lg:text-7xl" data-id="element-68" data-mp="3o73no75q7m5y" />
          </Reveal>
          <Reveal delay={0.14} data-id="element-69" data-mp="30i19j9aawbg7">
            <p className="mt-7 font-serif text-2xl text-white sm:text-3xl" data-id="element-70" data-mp="30gzwx0dmzgwd">
              ¿Cansad<span className="text-[#E0A526]" data-id="element-71" data-mp="3599ki9ra44vh">@</span> de buscar{' '}
              <span className="text-[#E0A526]" data-id="element-72" data-mp="35akoa9kq5cml">respuestas?</span>
            </p>
          </Reveal>
          <Reveal delay={0.18} data-id="element-73" data-mp="2qi0lxb5ef967">
            <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-white/75 sm:mx-0 sm:text-lg" data-id="element-74" data-mp="2vi53l4i1m9y0">
              Más de 30 años acompañando a familias hispanas en Estados Unidos con rituales,
              limpias y trabajos espirituales hechos con respeto, discreción y fe. Cuéntanos tu
              caso hoy mismo y recibe una orientación honesta.
            </p>
          </Reveal>
          <Reveal delay={0.22} data-id="element-75" data-mp="nat6xa8uyik6">
            <div className="mt-10 flex flex-wrap items-center justify-center gap-5 sm:justify-start" data-id="element-76" data-mp="n9qhz7v3iq6w">
              <IconCircleButton accion="llamada" tamano="lg" data-id="element-77" data-mp="icrnupbfmj8p" />
              <IconCircleButton accion="whatsapp" tamano="lg" data-id="element-78" data-mp="ddne9xklijhu" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}